/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, RuseState } from "react";
import * as UAPI from "../../services/UniversalAPI";
import { getCurrentUser } from "../../services/auth.service";

export default function JACK(props) {

  const updateNewConsentRegisterData = async (e) => {
    // ใช้ตอนแก้ teamusers.informConsent ไม่ได้ใช้อีก
    let filter = {
      filter: {
        where: {
          application: { in: ["OSCC"] }
        }
        // limit: 2
      }
    };
    // {"fields":["id"],"where":{"application":{"in":["OSCC"]}}}
    let response = await UAPI.getAll(filter, "teamusers");
    if (response.status === 200) {
      console.log(response.data);
      let u = response.data;
      u.map(i => {
        delete i['consent'];
        i['informConsent'] = { OSCC: { result: "consented", inform: { heading: { "CROH1": true, "CROH2": true, "CROH3": true, "CROH4": true, "CROH5": true, "CROH6": true }, detail: { "CROH1": true, "CROH2": true, "CROH3": true, "CROH4": true, "CROH5": true, "CROH6": true } }, consent: { heading: {}, detail: {} } } };

        let ud = {
          consent: null,
          informConsent: { OSCC: { result: "consented", inform: { heading: { "CROH1": true, "CROH2": true, "CROH3": true, "CROH4": true, "CROH5": true, "CROH6": true }, detail: { "CROH1": true, "CROH2": true, "CROH3": true, "CROH4": true, "CROH5": true, "CROH6": true } }, consent: { heading: {}, detail: {} } } }
        };

        UAPI.patch(i.id, ud, "teamusers").then((responseU) => {
          if (responseU.status === 200) {
            console.log(responseU.data);
          }
        });
        return null;
      });
    }

  };

  const updateServiceSlotPSu1 = async (e) => {
    // แก้ Serviceslot : PSu1 เพิ่ม answersDefault 
    let filter = {
      filter: {
        where: {
          "resultTemplate.questionnaire_code": "PSu1"
        }
        // limit: 2
      }
    };
    // {"skip":5,"limit":10,"where":{"resultTemplate.questionnaire_code":"PSu1"}}
    // {"fields":["id"],"where":{"application":{"in":["OSCC"]}}}
    let response = await UAPI.getAll(filter, "serviceslots");
    if (response.status === 200) {
      let x = response.data;
      // console.log(x);
      // console.log(x.resultTemplate[0]);
      x.forEach(x1 => {
        let resultTemplate = x1.resultTemplate;
        resultTemplate[0].questionsList.forEach(i1 => {
          if (i1.groupDescription === "ข้อมูลเพื่อติดต่อผู้เข้าร่วมโครงการ") {
            i1['groupQuestionsList'] = [
              {
                question: "ชื่อ",
                questionType: 1,
                answersList: [],
                answersDefault: "caseFirstName"
              },
              {
                question: "นามสกุล",
                questionType: 1,
                answersList: [],
                answersDefault: "caseLastName"
              },
              {
                question: "ที่อยู่ ",
                questionType: 1,
                answersList: [],
                answersDefault: "caseAddressInfo"
              },
              {
                question: "เบอร์โทรศัพท์ ",
                questionType: 1,
                answersList: [],
                answersDefault: "casePhoneNumber"
              }
            ];
          }
        });

        let ud = {
          resultTemplate: resultTemplate
        };
        console.log(ud);

        UAPI.patch(x1.id, ud, "serviceslots").then((responseU) => {
          if (responseU.status === 200) {
            console.log(responseU.data);
          }
        });

      });
      // console.log(x);
    }
  };

  const truncateServiceSlot = async (e) => {
    let filter = {
      filter: {}
    };
    let response = await UAPI.getAll(filter, "serviceslots");
    if (response.status === 200) {
      if (response.data) {
        let s = response.data;
        console.log(s);
        // const remove = (id, thisCollection, port) => {
        s.map(async (x) => {
          let z = await UAPI.remove(x.id, "serviceslots");
          console.log(x.id, x.hcode, x.serviceName, z);          
        });
      }
    }
  }

  const truncatePlanService = async (e) => {
    let filter = {
      filter: {}
    };
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status === 200) {
      if (response.data) {
        let s = response.data;
        console.log(s);
        // const remove = (id, thisCollection, port) => {
        s.map(async (x) => {
          let z = await UAPI.remove(x.id, "planservices");
          console.log(x.id, x.cause, z);          
        });
      }
    }
  }

  const deleteThesePlan = async () => {
    let x = ["6108eecacf110000910039c2","6108eecbcf110000910039ff","6108eecbcf11000091003a02","6108eecbcf11000091003a0a","6108eecbcf11000091003a1c","6133302f87460000de0009a1","6133303087460000de000d58","6133303087460000de000dec","6133303387460000de0014c3","6133303387460000de00156e","6133303987460000de002b45","6133304387460000de00488b","6133304687460000de0052b2","6133304d87460000de006883","6133304e87460000de006c43","6133304e87460000de006cb4","6133304e87460000de006e16","6133304e87460000de006e18","6133304e87460000de006e1b","6133304e87460000de006e1f","6133304e87460000de006e20","6133304e87460000de006e22","6133304e87460000de006e2d","6133304e87460000de006e31","6133304e87460000de006e42","6133304e87460000de006e43","6133304e87460000de006e47","6133304e87460000de006e51","6133304e87460000de006e52","6133304e87460000de006e58","6133304e87460000de006e5d","6133304e87460000de006e60","6133304e87460000de006e75","6133304f87460000de006e87","6133304f87460000de006e8f","6133304f87460000de006e90","6133304f87460000de006e9a","6133304f87460000de006e9e","6133304f87460000de006ea1","6133304f87460000de006ea2","6133304f87460000de006ebe","6133304f87460000de006ec0","6133304f87460000de006ecc","6133304f87460000de006ecf","6133304f87460000de006ed2","6133304f87460000de006edf","6133304f87460000de006efb","6133304f87460000de006f03","6133304f87460000de006f0a","6133304f87460000de006f1e","6133304f87460000de006f1f","6133304f87460000de006f25","6133304f87460000de006f36","6133304f87460000de006f37","6133304f87460000de006f44","6133304f87460000de006f47","6133304f87460000de006f4a","6133304f87460000de006f4f","6133304f87460000de006f52","6133304f87460000de006f56","6133304f87460000de006f5e","6133304f87460000de006f61","6133304f87460000de006f68","6133304f87460000de006f78","6133304f87460000de006f82","6133304f87460000de006f88","6133304f87460000de006f98","6133304f87460000de006f9b","6133304f87460000de006f9d","6133304f87460000de006fa5","6133304f87460000de006fa6","6133304f87460000de006faa","6133304f87460000de006fb0","6133304f87460000de006fb7","6133304f87460000de006fbf","6133304f87460000de006fda","6133304f87460000de006ffa","6133304f87460000de007014","6133304f87460000de007016","6133304f87460000de00702e","6133304f87460000de007033","6133304f87460000de00704a","6133304f87460000de00705b","6133304f87460000de007060","6133304f87460000de007063","6133304f87460000de007066","6133304f87460000de007067","6133304f87460000de007070","6133304f87460000de007073","6133304f87460000de007079","6133304f87460000de007080","6133304f87460000de00708a","6133304f87460000de00708e","6133304f87460000de00709b","6133304f87460000de00709f","6133304f87460000de0070a2","6133304f87460000de0070ab","6133304f87460000de0070b5","6133304f87460000de0070c3","6133304f87460000de0070c7","6133304f87460000de0070cf","6133304f87460000de0070d0","6133304f87460000de0070d8","6133304f87460000de0070e6","6133304f87460000de0070ee","6133304f87460000de0070f3","6133304f87460000de007106","6133304f87460000de007108","6133304f87460000de00710c","6133304f87460000de007115","6133304f87460000de007119","6133304f87460000de00711a","6133304f87460000de00711f","6133304f87460000de00712e","6133304f87460000de007136","6133304f87460000de00713a","6133304f87460000de007144","6133304f87460000de00714e","6133304f87460000de00715b","6133304f87460000de007167","6133304f87460000de007173","6133304f87460000de007183","6133304f87460000de007197","6133304f87460000de0071a1","6133304f87460000de0071a2","6133304f87460000de0071ac","6133304f87460000de0071c0","6133305987460000de009c85","6133305987460000de009d58"];

    let f = [];
    x.forEach(i => {
      f.push({osccPersonId:i});
    });
    let filter = {
      filter: {
        where: {
          or: f
        }
      }
    };

    let filterPlanId = [];
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status === 200) {
      if (response.data) {
        // console.log(response.data);
        response.data.forEach(i => {
          filterPlanId.push({id:i.id});
        });
      }
    }
    // console.log(filterPlanId);
    filterPlanId.map(async (i) => {
      console.log(i.id);
      let responseR = await UAPI.remove(i.id, "planservices");
      if (responseR.status === 200) {
        console.log(responseR.data);
      }
    });

    let osccPerson_ResetData = {
      "caseStatus": "new",
      "osccTeamId": [],
      "officerId": null,
      "careGiverUser": null,
      "caseStatusBeforeRemove": null,
      "caseUserId": null,
      "focusedCaseStatus": null
    };
    x.map(async (i) => {
      console.log(i);
      let responseP = await UAPI.patch(i, osccPerson_ResetData, "osccpeople");
      if (responseP.status === 200) {
        console.log(responseP.data);
      }
    });
  } 

  const addHcodeToPlans = async () => {
    console.log('addHcodeToPlans --- ');
    let hospitalData = [];
    let filterH = {
      filter: {
      }
    };
    let responseH = await UAPI.getAll(filterH, "hospitals");
    if (responseH.status === 200) {
      if (responseH.data) {
        if (responseH.data.length>0) {
          // console.log(responseH.data);
          hospitalData = responseH.data;
        }
      }
    }

    let planData = [];
    let filter = {
      filter: {
        // limit: 10
        where : { hcode: {eq:null}}
      }
    };
    let responseP = await UAPI.getAll(filter, "planservices");
    if (responseP.status === 200) {
      if (responseP.data) {
        if (responseP.data.length>0) {
          console.log(responseP.data);
          planData = responseP.data;
        }
      }
    }

    planData.forEach(pi => {
      hospitalData.forEach(hi => {
        if (hi.hos_name === pi.serviceslotList[0].teamName) {
          pi.hcode = hi.hos_id;
        }
      });
      if (pi.serviceslotList.length>0) {
        if (pi.serviceslotList[0].teamName==="รพร.ท่าบ่อ") {
          pi.hcode='11448';
        }
        if (pi.serviceslotList[0].teamName==="รพ.สต.บ้านกุดกระสู้") {
          pi.hcode='04194';
        }
        if (pi.serviceslotList[0].teamName==="รพ.สต.กุดหมากไฟ") {
          pi.hcode='13910';
        }
        if (pi.serviceslotList[0].teamName==="รพ.สต.บ้านนาข่า") {
          pi.hcode='04498';
        }
        if (pi.serviceslotList[0].teamName==="รพร.สว่างแดนดิน") {
          pi.hcode='11450';
        }
      }
      else {
        console.log('มี PLAN ที่ serviceslotList ว่าง ***********');
      }
    });

    // let  planNoH = [];
    // planData.forEach(pi => {
    //   let noh = null;
    //   if (!pi.hcode) {
    //     // console.log(pi.serviceslotList[0].teamName);
    //     noh = pi.serviceslotList[0].teamName;
    //   }
    //   if (pi.hcode==='') {
    //     // console.log(pi.serviceslotList[0].teamName);
    //     noh = pi.serviceslotList[0].teamName;
    //   }
    //   if (typeof pi.hcode === 'undefined') {
    //     // console.log(pi.serviceslotList[0].teamName);
    //     noh = pi.serviceslotList[0].teamName;
    //   }
      
    //   if (planNoH.indexOf(noh)===-1) {
    //     if (noh) {
    //       planNoH.push(noh);
    //     }
    //   }
    // });
    // console.log(planNoH);

    await Promise.all(planData.map(async (pi) => {
      let data = { hcode: pi.hcode };
      await UAPI.patch(pi.id, data, "planservices").then((responseU) => {
        if (responseU.status === 200) {
          console.log(responseU.data);
        }
      });
    }));   
  }

  const checkPlanSSID = async () => {
    let filter = {
      filter: {
        where: {
          cause: { like : "OSCC PLH 8 สัปดาห์" }
        }
        // limit: 2
      }
    };
    let x = [];
    console.log(JSON.stringify(filter.filter));
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status === 200) {
      if (response.data) {
        x = response.data;
        // console.log(x);
      }
    }
    let planMustUpdate = [];
    x.forEach(i => {
      i.serviceslotList.forEach(ii => {
        if (typeof ii.serviceSlotId !== 'undefined') {
          // console.log(ii);
          ii.serviceslotId = ii.serviceSlotId;
          delete ii['serviceSlotId'];
          planMustUpdate.push(i);
        }
      });
    });
    console.log(planMustUpdate.length);
    console.log(planMustUpdate);
    // let n = 0;
    // await Promise.all(planMustUpdate.map(async (pi) => {
    //   let data = { serviceslotList: pi.serviceslotList };
    //   // console.log(data);
    //   await UAPI.patch(pi.id, data, "planservices").then((responseU) => {
    //     if (responseU.status === 200) {
    //       ++n;
    //       console.log(n);
    //       console.log(responseU.data);
    //     }
    //   });
    // }));  
  }

  const checkPlan_ServiceSlotList = async () => {
    let filter = {
      filter: {
        // limit: 2
      }
    };
    let x = [];
    console.log(JSON.stringify(filter.filter));
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status === 200) {
      if (response.data) {
        x = response.data;
        console.log(x);
      }
    }
    let planMustUpdate = [];
    x.forEach(i => {
      i.serviceslotList.forEach(ii => {
        if (typeof ii.serviceSlotList !== 'undefined') {
          // console.log(ii);
          ii.serviceslotList = ii.serviceSlotList;
          delete ii['serviceSlotList'];
          planMustUpdate.push(i);
        }
      });
    });
    console.log(planMustUpdate.length);
    console.log(planMustUpdate);
    // let n = 0;
    // await Promise.all(planMustUpdate.map(async (pi) => {
    //   let data = { serviceslotList: pi.serviceslotList };
    //   // console.log(data);
    //   await UAPI.patch(pi.id, data, "planservices").then((responseU) => {
    //     if (responseU.status === 200) {
    //       ++n;
    //       console.log(n);
    //       console.log(responseU.data);
    //     }
    //   });
    // }));  
  }

  const checkServiceSlotSSID = async () => {
    let filter = {
      filter: {
        where: {
          serviceSlotCode: "PLH8wks1st"
        }
        // limit: 2
      }
    };
    let x = [];
    console.log(JSON.stringify(filter.filter));
    let response = await UAPI.getAll(filter, "serviceslots");
    if (response.status === 200) {
      if (response.data) {
        x = response.data;
        console.log(x);
      }
    }
    let serviceslotsMustUpdate = [];
    x.forEach(i => {
      let mustupdate = false;
      i.serviceSlotList.forEach(ii => {
        if (typeof ii.serviceSlotId !== 'undefined') {
          // console.log(ii);
          mustupdate= true;
          ii.serviceslotId = ii.serviceSlotId;
          delete ii['serviceSlotId'];
        }
        if (typeof ii.serviceSlotList !== 'undefined') {
          mustupdate= true;
        }
      });
      if (mustupdate=== true) {
        serviceslotsMustUpdate.push(i);
      }
    });
    console.log(serviceslotsMustUpdate.length);
    console.log(serviceslotsMustUpdate);
    // let n = 0;
    // await Promise.all(serviceslotsMustUpdate.map(async (pi) => {
    //   let data = JSON.parse(JSON.stringify(pi));
    //   data['serviceslotCode']=pi['serviceSlotCode'];
    //   data['serviceslotList']=pi['serviceSlotList'];
    //   delete data['serviceSlotCode'];
    //   delete data['serviceSlotList'];
    //   // console.log(data);
    //   await UAPI.update(pi.id, data, "serviceslots").then((responseU) => {
    //     if (responseU.status === 200) {
    //       ++n;
    //       console.log(n);
    //       console.log(responseU.data);
    //     }
    //   });
    // }));  
  }

  const checkPlanSSDATE = async () => {
    console.log('checkPlanSSDATE--- ');

    const calcDate = (startDate, days) => {
      let date = new Date(startDate);
      date.setDate(date.getDate() + days - 1);
      var d = date.getFullYear()+'-'+('00'+(date.getMonth()+1)).slice(-2)+'-'+('00'+date.getDate()).slice(-2);
      return d;
    }

    let filterS = {
      filter: {
        where: {
          key: "bluePrintServiceSlotOSCCPLH8wks1st"
        }
      }
    };
    let blueprint = [];
    // console.log(JSON.stringify(filter.filter));
    let responseS = await UAPI.getAll(filterS, "systemsettings");
    if (responseS.status === 200) {
      if (responseS.data) {
        blueprint = responseS.data[0].value.serviceslotList;
        console.log(blueprint);
      }
    }


    let filter = {
      // filter: {
      //   limit: 100
      // }
    };
    let x = [];
    // console.log(JSON.stringify(filter.filter));
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status === 200) {
      if (response.data) {
        x = response.data;
        console.log(x);
      }
    }
    let planMustUpdate = [];
    x.forEach(i => {
      let isnan = false;
      if (typeof i.serviceslotList !== 'undefined') {
        if (i.serviceslotList) {
          if (i.serviceslotList.length>0) {
            // console.log(i.serviceslotList.length);
            i.serviceslotList.forEach(i2 => {
              // console.log(i2.startDate, i2.endDate);
              if (i2.startDate==='NaN-NaN-NaN'||i2.endDate==='NaN-NaN-NaN') {
                // console.log(i2);
                isnan = true;
              }
            });
          }
        }
      }
      if (isnan === true) {
        planMustUpdate.push(i);
      }
    });

    console.log(planMustUpdate.length);
    if (planMustUpdate.length>0) {
      // console.log(planMustUpdate);
      planMustUpdate.forEach(i => {
        i.serviceslotList.forEach(i2 => {
          blueprint.forEach(i3 => {
            if (i2.sequenceId===i3.sequenceId) {
              // console.log(i3);
              if (i2.startDate==='NaN-NaN-NaN') {
                i2.startDate = calcDate(i.startDate, i3.startDays);
              }
              if (i2.endDate==='NaN-NaN-NaN') {
                i2.endDate = calcDate(i.startDate, i3.endDays);
              }
            }
          });
        });
      });
      console.log(planMustUpdate);
    }
    await Promise.all(planMustUpdate.map(async (pi) => {
      let data = { serviceslotList: pi.serviceslotList };
      await UAPI.patch(pi.id, data, "planservices").then((responseU) => {
        if (responseU.status === 200) {
          console.log(responseU.data);
        }
      });
    }));
  }

  const checkPlanNoConsentInterventionId = async () => {
    console.log('checkPlanNoConsentInterventionId--- ');
    // ผลพวงจากโค้ดที่ผิดพลาด ทำให้มี plan ที่ไม่มีผล consent แต่มี interventionId ซึ่งผลคำตอบของ บสถ นั่น ใน intervention ก็ไม่มีนะ
    let filter = {
      filter: {
        limit: 1000 ,skip : 4000
        // where: { id : '617b7a1570d95874ab26662e' }
      }
    };
    let x = [];
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status===200) {
      if (response.data) {
        if (response.data.length>0) {
          x = response.data;
        }
      }
    }

    console.log(x);
    let z = [];
    let interventionIdList = [];
    x.forEach(i => {
      let markThisPlan = false;
      if (typeof i.serviceslotList !== 'undefined') {
        if (i.serviceslotList) {
          if (i.serviceslotList.length>0) {
            i.serviceslotList.forEach(s => {
              if (typeof s.interventionId !== 'undefined') {
                if (s.interventionId) {
                  if (s.interventionId!=='') {
                    if (typeof s.consent === 'undefined') {
                      // console.log('A' ,s.interventionId, s.consent);
                      s.markThisPlan = true;
                      markThisPlan = true;
                      if (interventionIdList.indexOf(s.interventionId)<0) {
                        interventionIdList.push(s.interventionId);
                      }
                    }
                    else {
                      if (typeof s.consent.result ==='undefined') {
                        // console.log('B' ,s.interventionId, s.consent);
                        // console.log(s);
                        s.markThisPlan = true;
                        markThisPlan = true;
                        if (interventionIdList.indexOf(s.interventionId)<0) {
                          interventionIdList.push(s.interventionId);
                        }
                      }
                    }
                  }
                }
              }
            });
          }
        }
      }
      if (markThisPlan===true) {
        z.push(i);
      }
    });
    // console.log(z);
    console.log(interventionIdList);

    let interventionData = [];
    if (interventionIdList.length>0) {
      let f_interventionIdList = [];
      interventionIdList.forEach(i => {
        f_interventionIdList.push({ id: i });
      });
      let filter = {
        filter: {
          where: {
            or : f_interventionIdList
          }
        }
      };
      console.log(JSON.stringify(filter.filter));
      let responseI = await UAPI.getAll(filter, "interventions");
      if (responseI.status===200) {
        if (responseI.data) {
          if (responseI.data.length>0) {
            interventionData = responseI.data;
            console.log(responseI.data);
          }
        }
      }
    }
    console.log(interventionData);

    z.forEach(i => {
      i.serviceslotList.forEach(s => {
        if (typeof s.markThisPlan !== 'undefined') {
          if (s.markThisPlan===true) {
            console.log(s);
            interventionData.forEach(iv => {
              if (iv.id===s.interventionId) {
                if (typeof iv.activities !== 'undefined') {
                  if (typeof iv.activities.homeservice !== 'undefined') {
                    if (iv.activities.homeservice) {
                      if (iv.activities.homeservice.length>0) {
                        iv.activities.homeservice.forEach(hs => {
                          if (typeof hs.serviceType !== 'undefined') {
                            if (hs.serviceType === 'oscc' || hs.serviceType === 'OSCC') {
                              if (typeof hs.questionnaire !== 'undefined') { 
                                if (hs.questionnaire) { 
                                  if (hs.questionnaire.length>0) { 
                                    hs.questionnaire.forEach(qn => {
                                      let sequenceId = '';
                                      if (typeof qn.sequenceId !== 'undefined') {
                                        if (qn.sequenceId && qn.sequenceId!=='') {
                                          sequenceId=qn.sequenceId;
                                        }
                                      }
                                      if (s.sequenceId !== '' && s.sequenceId===sequenceId && i.id===s.planServiceId) {
                                        // console.log(sequenceId);
                                        // console.log(s);
                                        delete s.markThisPlan;
                                      }
                                    });
                                  }
                                }
                              }
                            }
                          }
                        });
                      }
                    }
                  }
                }
              }
            });
          }
        }
      });
    });


    let n = 0;
    await Promise.all(z.map(async (i) => {
      // console.log(i);
      i.serviceslotList.forEach(s => {
        // console.log(s.sequenceId, s.markThisPlan);
        if (typeof s.markThisPlan !== 'undefined') {
          if (s.markThisPlan===true) {
            delete s.markThisPlan;
            delete s.interventionDate;
            delete s.interventionId;
            // console.log(s);
          }
        }
      });
      let ud = {
        serviceslotList: i.serviceslotList
      };
      // console.log(ud);
      await UAPI.patch(i.id, ud, "planservices").then((responseU) => {
        if (responseU.status === 200) {
          ++n;
          console.log(n);
          console.log(responseU.data);
        }
      });
    }));


  }

  const checkPersonID_in_planService = async (e) => {
    let plans = [];
    let filter = {
      filter: {
        // limit: 500,
        // skip: 0
      }
    };
    let response = await UAPI.getAll(filter, "planservices");
    if (response.status === 200) {
      if (response.data) {
        if (response.data.length>0) {
          console.log(response.data);
          plans = response.data;
        }
      }
    }
    console.log('plans.length= ',plans.length);

    let plansMustUpdate = [];
    let iids = [];
    if (plans.length>0) {
      plans.forEach(i1 => {
        let mustUpdate = false;
        if (typeof i1.serviceslotList !== 'undefined') {
          if (i1.serviceslotList) {
            if (i1.serviceslotList.length>0) {
              i1.serviceslotList.forEach(i2 => {
                if (i2) {
                  if (typeof i2.interventionId !== 'undefined') {
                    if (i2.interventionId) {
                      if (i2.interventionId!=='') {
                        mustUpdate = true;
                      }
                      if (iids.indexOf(i2.interventionId)<0) {
                        iids.push(i2.interventionId);
                      }
                    }
                  }
                }
              });
            }
          }
        }
        if (mustUpdate===true) {
          plansMustUpdate.push(i1);
        }
      });
    }
    console.log(plansMustUpdate);
    console.log(iids);
    let interventions = [];
    if (iids.length>0) {
      let f_or = [];
      iids.forEach(i => {
        f_or.push({ id: i });
      });
      let filter_i = {
        filter: {
          where: {
            or: f_or
          }
        }
      };
      let response = await UAPI.getAll(filter_i, "interventions");
      if (response.status === 200) {
        if (response.data) {
          if (response.data.length>0) {
            // console.log(response.data);
            interventions=response.data;
          }
        }
      }
      console.log(interventions);
      
      plansMustUpdate.forEach(i1 => {
        if (typeof i1.serviceslotList !== 'undefined') {
          if (i1.serviceslotList) {
            if (i1.serviceslotList.length>0) {
              i1.serviceslotList.forEach(i2 => {
                if (i2) {
                  if (typeof i2.interventionId !== 'undefined') {
                    if (i2.interventionId) {
                      interventions.forEach(i3 => {
                        if (i3.id===i2.interventionId) {
                          i1['personId'] = i3.personId;
                        }
                      });
                    }
                  }
                }
              });
            }
          }
        }
      });
      console.log(plansMustUpdate);
      let n=0;
      await Promise.all(plansMustUpdate.map(async (i) => {
        // console.log(i);
        let ud = {
          personId: i.personId
        };
        // console.log(i.id, ud);
        await UAPI.patch(i.id, ud, "planservices").then((responseU) => {
          if (responseU.status === 200) {
            ++n;
            console.log(n);
            console.log(responseU.data);
          }
        });
      }));
    }
  };


  useEffect(() => {
    // updateNewConsentRegisterData();
    // updateServiceSlotPSu1();
    // truncateServiceSlot();
    // truncatePlanService();
    // deleteThesePlan();
    // addHcodeToPlans();
    // checkPlanSSID();

    // checkServiceSlotSSID();
    // ปัญหา servcieslotList ตกลงให้ใช้ servcieslotList ไม่ใช่ servcieSlotList 
    // ใน planservcei ไม่มี servcieSlotList ดังนั้นแก้แต่ใน systemsetting และ servcieslot
    // checkPlan_ServiceSlotList();

    // checkPlanSSDATE();
    // checkPlanNoConsentInterventionId();
    // checkPersonID_in_planService();

  }, []);

  return (
    <div style={{ marginBottom: 100 }}>
      ||||||||
    </div>
  );
}